// ============================================================
// DM-LMS — Dev role helpers
// DEV ONLY (import.meta.env.DEV): the selected role lives in localStorage
// and is sent as X-Dev-Role so the API can impersonate a seeded user.
// Every export is inert in production builds — getDevRole() returns null.
// ============================================================

import { ROLES, type Role } from "@dm-lms/shared/types";
import { DEV_ROLE_HEADER, DEV_ROLE_STORAGE_KEY } from "@dm-lms/shared/constants";

export function getDevRole(): Role | null {
  if (!import.meta.env.DEV) return null;
  try {
    const stored = localStorage.getItem(DEV_ROLE_STORAGE_KEY);
    return ROLES.find((role) => role === stored) ?? null;
  } catch {
    return null;
  }
}

export function setDevRole(role: Role): void {
  try {
    localStorage.setItem(DEV_ROLE_STORAGE_KEY, role);
  } catch {
    // storage unavailable — switcher simply has no effect
  }
}

// Spread into every fetch's headers.
export function devRoleHeaders(): Record<string, string> {
  if (!import.meta.env.DEV) return {};
  const role = getDevRole();
  return role ? { [DEV_ROLE_HEADER]: role } : {};
}
